import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import logoImg from '../assets/logo/logo.png';
import buddhaImg from '../assets/buddha.jpeg';
import { useAuth } from '../contexts/AuthContext';

const navItems = [
  { label: 'Rooms', href: '/#rooms' },
  { label: 'Menu', href: '/menu' },
  { label: 'Book', href: '/book' },
  { label: 'Contact', href: '#contact' },
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { isLoggedIn } = useAuth();
  const items = isLoggedIn ? [...navItems, { label: 'Account', href: '/account' }] : navItems;

  return (
    <Box
      component="header"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        bgcolor: 'rgba(250,248,245,0.92)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(44,41,38,0.06)',
        backgroundImage: `url(${buddhaImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(250,248,245,0.85)',
          backdropFilter: 'blur(8px)',
          pointerEvents: 'none',
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          maxWidth: 1200,
          mx: 'auto',
          px: 3,
          py: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Link
          to="/"
          style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none', color: 'inherit' }}
        >
          <Box
            component="img"
            src={logoImg}
            alt="Chan's Nest Inn"
            sx={{ height: 40, width: 'auto', objectFit: 'contain' }}
          />
          <Typography
            sx={{
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              fontSize: '1.5rem',
              fontWeight: 600,
              color: 'var(--color-charcoal)',
            }}
          >
            Chan's Nest Inn
          </Typography>
        </Link>
        <Box
          sx={{
            display: { xs: 'none', md: 'flex' },
            gap: 4,
          }}
        >
          {items.map((item) => {
            const isHash = item.href.startsWith('/#') || item.href.startsWith('#');
            return isHash ? (
              <Box
                key={item.label}
                component="a"
                href={item.href}
                sx={{
                  color: 'var(--color-warm-gray)',
                  textDecoration: 'none',
                  fontSize: '0.95rem',
                  fontWeight: 500,
                  '&:hover': { color: 'var(--color-charcoal)' },
                  transition: 'color 0.2s',
                }}
              >
                {item.label}
              </Box>
            ) : (
              <Box
                key={item.label}
                component={Link}
                to={item.href}
                sx={{
                  color: 'var(--color-warm-gray)',
                  textDecoration: 'none',
                  fontSize: '0.95rem',
                  fontWeight: 500,
                  '&:hover': { color: 'var(--color-charcoal)' },
                  transition: 'color 0.2s',
                }}
              >
                {item.label}
              </Box>
            );
          })}
        </Box>
        <IconButton
          sx={{ display: { md: 'none' } }}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="menu"
        >
          {mobileOpen ? <CloseIcon /> : <MenuIcon />}
        </IconButton>
      </Box>
      {mobileOpen && (
        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            display: { md: 'none' },
            py: 2,
            px: 3,
            bgcolor: 'rgba(250,248,245,0.98)',
            borderTop: '1px solid rgba(44,41,38,0.06)',
          }}
        >
          {items.map((item) => {
            const isHash = item.href.startsWith('/#') || item.href.startsWith('#');
            const href = isHash ? (item.href.startsWith('/') ? item.href : `${window.location.pathname}${item.href}`) : undefined;
            return (
              <Box
                key={item.label}
                component={isHash ? 'a' : Link}
                to={isHash ? undefined : item.href}
                href={href}
                onClick={() => setMobileOpen(false)}
                sx={{
                  display: 'block',
                  py: 1.5,
                  color: 'var(--color-charcoal)',
                  textDecoration: 'none',
                  fontSize: '1rem',
                  fontWeight: 500,
                  '&:hover': { color: 'var(--color-accent)' },
                }}
              >
                {item.label}
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
};

export default Header;
